import { GET_DATA_TABLEREPORT_PLANHANDLE } from "../actions/actionTypes";
import {
  GetDataTableReportHandleSuccessAction,
  RequestTableReportHandleFaileAction,
} from "../actions";

import { put, takeLatest } from "redux-saga/effects";
import { Api } from "./api";

function* GetDataTableReport(action) {
  try {
    const DataTableReport = yield Api.GetDataTableReportFromApi(action.id, action.dataTables);
    yield put(GetDataTableReportHandleSuccessAction(DataTableReport));
  } catch (error) {
    yield put(RequestTableReportHandleFaileAction(error));
  }
}
export function* watchGetDataTableReport() {
  yield takeLatest(GET_DATA_TABLEREPORT_PLANHANDLE, GetDataTableReport);
}
